import React, { Component } from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';

import './App.css';

import Home from '../Home/Home';
import Header from '../Header/Header';
import Default from '../Default';
import Results from '../Results/Results';
import Footer from '../Footer/Footer';
import PromoVid from '../PromoVid/PromoVid';
import Quiz from '../Question/Quiz';
import VideoQuiz from '../Question/VideoQuiz';
import HighScores from '../HighScores/HighScores';

class App extends Component {

  constructor() {
    super()
    this.state = {
      quiz: ""
    }
  }

  onSelectQuiz = (quiz) => {
    this.setState({ quiz })
    window.location = "/trivia/intro?quiz=" + quiz
  }

  render() {
    return (
      <div className="App">
        <Header />
        <BrowserRouter>
          <Switch>
            <Route exact path="/" render={ (props) => <Home onSelectQuiz={this.onSelectQuiz} /> } />
            <Route path="/trivia/intro" render={ (props) => <PromoVid /> } />
            <Route exact path="/trivia/lyrics/questions" component={ Quiz } />
            {/* <Route exact path="/trivia/video/questions" component={ VideoQuiz } /> */}
            <Route path="/results" component={ Results } />
            <Route path="/high-scores" render={ (props) => <HighScores limit={50} /> } />
            <Route component={ Default } />
          </Switch>
        </BrowserRouter>
        <Footer />
      </div>
    );
  }
}

export default App;
